import { atom } from 'jotai';

import {
  $explicitSavedTemplateIds,
  $selectedTemplateId,
  $selectedTemplateType,
  TEMPLATE_TYPE_TO_SETTING_ID,
} from '../_state/locationDocumentTemplate.state';

import { FileTemplateType } from './queryFileTemplates';

// TODO: Replace with actual GraphQL mutation when backend is ready
// The mutation should call corePatchScopedSettingValues with:
// - scope: 'Facility'
// - objectId: facilityId
// - values: { [settingId]: templateFileId }
export const $saveFacilityTemplateSetting = atom(
  null,
  async (
    get,
    set,
    params: {
      facilityId: string;
      templateType: FileTemplateType;
      templateId: string;
    },
  ) => {
    const _settingId = TEMPLATE_TYPE_TO_SETTING_ID[params.templateType];

    // Mock implementation - simulates saving by updating local state
    // In the real implementation, this would call the GraphQL mutation
    await new Promise((resolve) => setTimeout(resolve, 500));

    set($explicitSavedTemplateIds, (prev) => ({
      ...prev,
      [params.templateType]: params.templateId,
    }));

    return { success: true };
  },
);

export const $saveCurrentTemplateSetting = atom(
  null,
  async (get, set, facilityId: string) => {
    const templateType = get($selectedTemplateType);
    const templateId = get($selectedTemplateId);

    if (!templateId) {
      throw new Error('No template selected');
    }

    return set($saveFacilityTemplateSetting, {
      facilityId,
      templateType,
      templateId,
    });
  },
);
